import { useState } from 'react';
import useMediaQuery from 'hooks/useMediaQuery';
import { Dropdown } from '../Dropdown/Dropdown';
import { countriesArray } from '../HeaderNew/CountrySelector/mockData';
import { contacts } from './mockData';
import office from 'images/office.jpg';
import './styles.scss';

const DistributionContacts = () => {
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regions, setRegions] = useState([]);

    const isTablet = useMediaQuery('max-width: 1023px');

    const onChangeCountry = item => {
        const distributors = contacts.find(el => el.country === item.name)?.regions;

        if (distributors) {
            setSelectedCountry(item.name);
            setSelectedRegion(distributors[0]);
            const countryRegions = distributors?.map(el => ({ name: el.region }));
            setRegions(countryRegions);
        } else {
            setSelectedCountry('');
            setSelectedRegion(null);
            setRegions([]);
        }
    };

    const onChangeRegion = region => {
        const updatedRegion = contacts
            .find(el => el.country === selectedCountry)
            ?.regions.find(el => el.region === region.name);
        setSelectedRegion(updatedRegion);
    };

    return (
        <section className="container">
            <div className="distribution-contacts">
                <div className="distribution-contacts__contacts-wrapper">
                    <div className="distribution-contacts__contacts-wrapper__contacts">
                        <p className="description-medium">
                            To view contacts of distributors and regional representatives, choose a country
                        </p>
                        <div className="dropdowns">
                            <Dropdown
                                label="PLEASE CHOOSE A COUNTRY"
                                options={countriesArray}
                                onDropdownChange={onChangeCountry}
                            />
                            {selectedCountry && (
                                <Dropdown
                                    label="PLEASE CHOOSE A CITY OR REGION"
                                    options={regions}
                                    onDropdownChange={onChangeRegion}
                                />
                            )}
                        </div>
                    </div>
                    {selectedCountry && !isTablet && (
                        <div className="distribution-contacts__contacts-wrapper__distributor">
                            <img src={selectedRegion.avatar} alt={selectedRegion.name} />
                            <p className="description-demibold">{selectedRegion.name}</p>
                            <p className="body1">{selectedRegion.description}</p>
                            <a
                                className="distribution-contacts__contact button-text distributor-phone"
                                href={`tel:${selectedRegion.phone}`}
                            >
                                {selectedRegion.phone}
                            </a>
                            <a
                                className="distribution-contacts__contact button-text distributor-email"
                                href={`mailto:${selectedRegion.email}`}
                            >
                                {selectedRegion.email.toUpperCase()}
                            </a>
                        </div>
                    )}
                </div>
                {selectedCountry ? <img src={selectedRegion.map} alt="map" /> : <img src={office} alt="office" />}
                {selectedCountry && isTablet && (
                    <div className="distribution-contacts__contacts-wrapper__distributor">
                        <img src={selectedRegion.avatar} alt={selectedRegion.name} />
                        <p className="description-demibold">{selectedRegion.name}</p>
                        <p className="body1">{selectedRegion.description}</p>
                        <a
                            className="distribution-contacts__contact button-text distributor-phone"
                            href={`tel:${selectedRegion.phone}`}
                        >
                            {selectedRegion.phone}
                        </a>
                        <a
                            className="distribution-contacts__contact button-text distributor-email"
                            href={`mailto:${selectedRegion.email}`}
                        >
                            {selectedRegion.email.toUpperCase()}
                        </a>
                    </div>
                )}
            </div>
        </section>
    );
};

export default DistributionContacts;
